import { render, staticRenderFns } from "./DraftDetails.vue?vue&type=template&id=530c0eba"
import script from "./DraftDetails.vue?vue&type=script&lang=js"
export * from "./DraftDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports